// Outbox offline-first (Paso 6 / Fase 4 del plan offline).
//
// Cola persistente de ESCRITURAS que todavia no se confirmaron en el backend.
// Cuando no hay red (o como garantia de durabilidad incluso online), las
// mutaciones se encolan aca primero y un "drainer" las drena contra
// POST /api/sync/batch al reconectar. Sobrevive recargas/cierres de la app
// porque vive en IndexedDB.
//
// DB SEPARADA del cache de lectura (`cf_query_cache`, en queryClient.js): esto
// es el log de operaciones pendientes, no el cache de TanStack Query.
//
// Forma de una fila (OutboxRow):
//   id         number   autoincrement local (PK Dexie)
//   clientUuid string   UUID generado por el cliente; clave de idempotency
//                       contra el backend (mismo uuid => no duplica)
//   entity     string   "comment" | "weight" | "treatmentEvent" | ... (entidad del batch)
//   operation  string   "CREATE" (el batch hoy solo soporta CREATE)
//   payload    object   DTO Java a enviar (ya incluye clientUuid adentro)
//   status     string   "pending" | "in_flight" | "synced" | "conflict" | "error"
//   retries    number   intentos fallidos acumulados
//   lastError  string?  ultimo mensaje de error
//   createdAt  number   epoch ms de encolado (orden FIFO)
//   syncedAt   number?  epoch ms cuando se confirmo
//   serverId   number?  id asignado por el server al confirmar
import Dexie from "dexie";

class OutboxDb extends Dexie {
    constructor() {
        super("cf_outbox");
        // Indices: status (filtrar pendientes), createdAt (orden FIFO),
        // clientUuid (dedupe/reconciliacion), entity (filtrar por tipo).
        this.version(1).stores({
            outbox: "++id, clientUuid, status, createdAt, entity",
        });
        // v2 (multi-establecimiento): cada operacion lleva el establishmentId
        // al que pertenece, para que el drainer la drene con el token scoped a
        // ese establecimiento. Filas viejas quedan con establishmentId
        // undefined -> el drainer las agrupa bajo el establecimiento activo.
        this.version(2).stores({
            outbox: "++id, clientUuid, status, createdAt, entity, establishmentId",
        });
        // v3 (cadena de dependencias offline): mapa clientUuid -> serverId que
        // aprende el drainer al confirmarse cada CREATE. Sirve para resolver las
        // FK temporales "pending-<clientUuid>" de los hijos creados offline (una
        // observación/pesaje para un animal recién creado sin conexión) antes de
        // mandarlos. Tabla SEPARADA del outbox porque markSynced BORRA la fila
        // del outbox al confirmar, y el hijo puede drenarse en un ciclo posterior.
        //   { clientUuid, serverId, createdAt }
        this.version(3).stores({
            outbox: "++id, clientUuid, status, createdAt, entity, establishmentId",
            idmap: "clientUuid, createdAt",
        });
    }
}

export const outboxDb = new OutboxDb();
